import axios from "axios";
import config from "./config";

const AuthApi = {

    register: async (
        login: string,
        email: string,
        name: string = '',
        surname: string = '',
        fatherName: string = '',
        company: string = '',
    ) => {
        try {
            const response = await axios.post(config.host + '/login/register',
                JSON.stringify({
                    login: login,
                    email: email,
                    name: name,
                    surname: surname,
                    fatherName: fatherName,
                    company: company
                })
                );
            return response.data;
        } catch (error) {
            throw new Error('Error send register');
        }
    },

    sendCode: async (
        login: string
    ) => {
        try {
            const response = await axios.post(config.host + '/login/code',
                JSON.stringify({
                    login: login,
                })
            );
            return response.data;
        } catch (error) {
            throw new Error('Error send sms-code');
        }
    },

    verify: async (userId: number, code: string) => {
        try {
            const response = await axios.post(config.host + '/login/verify',
                JSON.stringify({
                    id: userId,
                    code: code
                })
            );
            return response.data;
        } catch (error) {
            throw new Error('Error send verify');
        }
    },

    login: async (login: string, password: string) => {
        try {
            const response = await axios.post(config.host + '/login/auth',
                JSON.stringify({
                    login: login,
                    password: password
                })
            );
            return response.data;
        } catch (error) {
            throw new Error('Error send login');
        }
    },
    loginToken: async (token: string) => {
        try {
            const response = await axios.post(config.host + '/login/token',
                JSON.stringify({
                    token: token
                })
            );
            return response.data;
        } catch (error) {
            throw new Error('Error send login');
        }
    },
    ping: async () => {
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.post(config.host + '/api/private/ping', {}, axiosConfig);
            return response.data;
        } catch (error) {

        }
    }

}

export default AuthApi;
